import { Avatar, type AvatarProps } from '@affine/component';

import { useCachedUserAvatarUrl } from '../../modules/cloud/hooks/use-cached-user-avatar-url';

export type CachedUserAvatarProps = AvatarProps & {
  userId?: string | null;
};

export function CachedUserAvatar({
  userId,
  url,
  ...props
}: CachedUserAvatarProps) {
  const cachedUrl = useCachedUserAvatarUrl({
    userId,
    avatarUrl: url,
  });

  return <Avatar {...props} url={cachedUrl ?? url ?? null} />;
}
